import { Grid2, Typography, Box } from "@mui/material"
import CustomTextField from "../textfield/CustomTextField"
import { DateFormat, InvoiceStatus } from "../../constants/constants"
import { InvoiceDetails } from "../../interfaces/Invoicing.interfaces";
import { Label } from "@mui/icons-material";
import { isSMT } from "../../interfaces/userRoles";
import dayjs from "dayjs";
import useApi from "../../hooks/useApi";
import { headingStyles, subHeadingStyles } from "../../assets/styles/CommonStyles";
interface DetailsCardProps {
  Details: InvoiceDetails | null;
  role?: number;
}
const DetailsCard: React.FC<DetailsCardProps> = ({ Details }) => {
  if (!Details) return null;

  return (
    <>
      <Box
        sx={{
          mt: 2,
          p: 3,
          borderRadius: 2,
          border: "1px solid #dfe6ed",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
          backgroundColor: "#fff"
        }}
      >
        {/* HEADER */}
        <Typography
          sx={{
            fontSize: "20px",   // 🔥 increased
            fontWeight: 700,
            color: "#1e66ab",
            mb: 2
          }}
        >
          Invoice Details
        </Typography>

        <Grid2 container spacing={2}>

          {/* LEFT */}
          <Grid2 size={{ xs: 12, md: 4 }}>
            <Typography sx={{ mb: 1, fontSize: "15px" }}>
              <strong>Invoice Number:</strong> {Details.invoiceNumber}
            </Typography>

            <Typography sx={{ fontSize: "15px" }}>
              <strong>Status:</strong> {InvoiceStatus[Details.status]}
            </Typography>
          </Grid2>

          {/* MIDDLE */}
          <Grid2 size={{ xs: 12, md: 4 }}>
            <Typography sx={{ mb: 1, fontSize: "15px" }}>
              <strong>Submitted By:</strong> {Details.submittedByName}
            </Typography>

            <Typography sx={{ fontSize: "15px" }}>
              <strong>Submitted On:</strong>{" "}
              {dayjs(Details.submittedOn).format(DateFormat)}
            </Typography>
          </Grid2>

          {/* RIGHT */}
          <Grid2 size={{ xs: 12, md: 4 }}>

            {Details.status === InvoiceStatus.Approved && (
              <>
                <Typography sx={{ mb: 1, fontSize: "15px" }}>
                  <strong>Approved By:</strong> {Details.approvedBy}
                </Typography>

                <Typography sx={{ fontSize: "15px" }}>
                  <strong>Approved On:</strong>{" "}
                  {dayjs(Details.approvedOn).format(DateFormat)}
                </Typography>
              </>
            )}

            {Details.status === InvoiceStatus.Rejected && (
              <>
                <Typography sx={{ mb: 1, fontSize: "15px" }}>
                  <strong>Rejected By:</strong> {Details.rejectedBy}
                </Typography>

                <Typography sx={{ mb: 1, fontSize: "15px" }}>
                  <strong>Rejected On:</strong>{" "}
                  {dayjs(Details.rejectedDate).format(DateFormat)}
                </Typography>

                <Typography sx={{ fontSize: "15px" }}>
                  <strong>Reason:</strong> {Details.rejectedReason}
                </Typography>
              </>
            )}

          </Grid2>

        </Grid2>
      </Box>
    </>
  );
};
export default DetailsCard